var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"bg-white mb-4 lg:mb-8"},[_c('div',{staticClass:"py-3 border-b border-gray"},[_c('service-bar',{attrs:{"type":"simple","logo":_vm.logo}})],1),_vm._v(" "),_c('div',{staticClass:"block md:hidden"},[_c('portal-target',{attrs:{"name":"serviceCostsOverlay"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }